// https://www.daviddarling.info/encyclopedia/C/coefficient_of_linear_expansion.html
export function perDegreeCToPerDegreeF(perDegreeC: number) {
    return perDegreeC * 5 / 9;
}

export function perDegreeFToPerDegreeC(perDegreeC: number) {
    return perDegreeC * 9 / 5;
}
